import Pusher from 'pusher-js';
import { apiHost, apiHostName } from '../config';

// @ts-ignore
window.Pusher = Pusher;

const getEchoConfig = () => ({
  broadcaster: 'pusher',
  key: '123456',
  cluster: 'mt1',
  wsHost: apiHostName,
  wsPort: 8000,
  forceTLS: false,
  disableStats: true,
  authEndpoint: `${apiHost}/api/broadcasting/auth`,
  auth: {
    headers: {
      Authorization: localStorage.token,
    },
  },
});

export default getEchoConfig;
